import StateType, { BillingConfigurationType } from './state.type';

export default {
  toggleLoading(state: StateType, isLoading: boolean): void {
    state.loading = isLoading;
  },
  toggleLoadingSave(state: StateType, isLoading: boolean): void {
    state.loadingSave = isLoading;
  },
  setInvoiceConfiguration(state: StateType, billingConfiguration: BillingConfigurationType): void {
    state.billingConfiguration = billingConfiguration;
  },
  setPreSignedUrlCertificate(state: StateType, preSignedUrlCertificate: string): void {
    state.preSignedUrlCertificate = preSignedUrlCertificate;
  },
  setPreSignedUrlLogo(state: StateType, preSignedUrlLogo: string): void {
    state.preSignedUrlLogo = preSignedUrlLogo;
  },
};
